import { render } from "./LogoSettings.vue?vue&type=template&id=0979359c&scoped=true"
import script from "./LogoSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./LogoSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./LogoSettings.vue?vue&type=style&index=0&id=0979359c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0979359c"]])

export default __exports__